export const cognitoManageNames = [
  "family_name",
  "given_name",
  "family_name_kana",
  "given_name_kana",
  "manual_family_name",
  "manual_given_name",
  "phone_number",
  "email",
  "address",
  "address_first",
  "address_second",
  "post_code",
  "birthdate",
  "gender",
];

export const basicAttribute = [
  "address",
  "birthdate",
  "email",
  "family_name",
  "gender",
  "given_name",
  "phone_number",
  "updated_at",
];

export const requiredKeys = [
  "family_name_kana",
  "given_name_kana",
  "phone_number",
  "account_num",
  "account_person_name",
];

export const manualInputRequiredKeys = [
  "address_first",
];

export const judgeStatus = {
  judge: {
    label: "審査中",
    value: 0,
  },
  success: {
    label: "審査通過",
    value: 1,
  },
  is_dup_del_addr: {
    label: "受取先住所重複",
    value: 2,
  },
  is_dup_addr_tel: {
    label: "受取先電話重複",
    value: 3,
  },
  is_inputted_bank: {
    label: "銀行口座登録済み",
    value: 4,
  },
  invalid_bank: {
    label: "口座情報不正",
    value: 5,
  },
  failed_transfer: {
    label: "振込失敗",
    value: 6,
  },
}


export const nationalCodeList = [
  { label: "+81(日本)", value: "+81" },
  { label: "+1", value: "+1" },
  { label: "+2", value: "+2" },
  { label: "+3", value: "+3" },
  { label: "+4", value: "+4" },
  { label: "+5", value: "+5" },
  { label: "+6", value: "+6" },
  { label: "+7", value: "+7" },
  { label: "+8", value: "+8" },
  { label: "+9", value: "+9" },
  { label: "+10", value: "+10" },
  { label: "+11", value: "+11" },
  { label: "+12", value: "+12" },
  { label: "+13", value: "+13" },
  { label: "+14", value: "+14" },
  { label: "+15", value: "+15" },
  { label: "+16", value: "+16" },
  { label: "+17", value: "+17" },
  { label: "+18", value: "+18" },
  { label: "+19", value: "+19" },
  { label: "+20", value: "+20" },
  { label: "+21", value: "+21" },
  { label: "+22", value: "+22" },
  { label: "+23", value: "+23" },
  { label: "+24", value: "+24" },
  { label: "+25", value: "+25" },
  { label: "+26", value: "+26" },
  { label: "+27", value: "+27" },
  { label: "+28", value: "+28" },
  { label: "+29", value: "+29" },
  { label: "+30", value: "+30" },
  { label: "+31", value: "+31" },
  { label: "+32", value: "+32" },
  { label: "+33", value: "+33" },
  { label: "+34", value: "+34" },
  { label: "+35", value: "+35" },
  { label: "+36", value: "+36" },
  { label: "+37", value: "+37" },
  { label: "+38", value: "+38" },
  { label: "+39", value: "+39" },
  { label: "+40", value: "+40" },
  { label: "+41", value: "+41" },
  { label: "+42", value: "+42" },
  { label: "+43", value: "+43" },
  { label: "+44", value: "+44" },
  { label: "+45", value: "+45" },
  { label: "+46", value: "+46" },
  { label: "+47", value: "+47" },
  { label: "+48", value: "+48" },
  { label: "+49", value: "+49" },
  { label: "+50", value: "+50" },
  { label: "+51", value: "+51" },
  { label: "+52", value: "+52" },
  { label: "+53", value: "+53" },
  { label: "+54", value: "+54" },
  { label: "+55", value: "+55" },
  { label: "+56", value: "+56" },
  { label: "+57", value: "+57" },
  { label: "+58", value: "+58" },
  { label: "+59", value: "+59" },
  { label: "+60", value: "+60" },
  { label: "+61", value: "+61" },
  { label: "+62", value: "+62" },
  { label: "+63", value: "+63" },
  { label: "+64", value: "+64" },
  { label: "+65", value: "+65" },
  { label: "+66", value: "+66" },
  { label: "+67", value: "+67" },
  { label: "+68", value: "+68" },
  { label: "+69", value: "+69" },
  { label: "+70", value: "+70" },
  { label: "+71", value: "+71" },
  { label: "+72", value: "+72" },
  { label: "+73", value: "+73" },
  { label: "+74", value: "+74" },
  { label: "+75", value: "+75" },
  { label: "+76", value: "+76" },
  { label: "+77", value: "+77" },
  { label: "+78", value: "+78" },
  { label: "+79", value: "+79" },
  { label: "+80", value: "+80" },
  { label: "+82", value: "+82" },
  { label: "+83", value: "+83" },
  { label: "+84", value: "+84" },
  { label: "+85", value: "+85" },
  { label: "+86", value: "+86" },
  { label: "+87", value: "+87" },
  { label: "+88", value: "+88" },
  { label: "+89", value: "+89" },
  { label: "+90", value: "+90" },
  { label: "+91", value: "+91" },
  { label: "+92", value: "+92" },
  { label: "+93", value: "+93" },
  { label: "+94", value: "+94" },
  { label: "+95", value: "+95" },
  { label: "+96", value: "+96" },
  { label: "+97", value: "+97" },
  { label: "+98", value: "+98" },
  { label: "+99", value: "+99" },
  { label: "+100", value: "+100" },
  { label: "+101", value: "+101" },
  { label: "+102", value: "+102" },
  { label: "+103", value: "+103" },
  { label: "+104", value: "+104" },
  { label: "+105", value: "+105" },
  { label: "+106", value: "+106" },
  { label: "+107", value: "+107" },
  { label: "+108", value: "+108" },
  { label: "+109", value: "+109" },
  { label: "+110", value: "+110" },
  { label: "+111", value: "+111" },
  { label: "+112", value: "+112" },
  { label: "+113", value: "+113" },
  { label: "+114", value: "+114" },
  { label: "+115", value: "+115" },
  { label: "+116", value: "+116" },
  { label: "+117", value: "+117" },
  { label: "+118", value: "+118" },
  { label: "+119", value: "+119" },
  { label: "+120", value: "+120" },
  { label: "+121", value: "+121" },
  { label: "+122", value: "+122" },
  { label: "+123", value: "+123" },
  { label: "+124", value: "+124" },
  { label: "+125", value: "+125" },
  { label: "+126", value: "+126" },
  { label: "+127", value: "+127" },
  { label: "+128", value: "+128" },
  { label: "+129", value: "+129" },
  { label: "+130", value: "+130" },
  { label: "+131", value: "+131" },
  { label: "+132", value: "+132" },
  { label: "+133", value: "+133" },
  { label: "+134", value: "+134" },
  { label: "+135", value: "+135" },
  { label: "+136", value: "+136" },
  { label: "+137", value: "+137" },
  { label: "+138", value: "+138" },
  { label: "+139", value: "+139" },
  { label: "+140", value: "+140" },
  { label: "+141", value: "+141" },
  { label: "+142", value: "+142" },
  { label: "+143", value: "+143" },
  { label: "+144", value: "+144" },
  { label: "+145", value: "+145" },
  { label: "+146", value: "+146" },
  { label: "+147", value: "+147" },
  { label: "+148", value: "+148" },
  { label: "+149", value: "+149" },
  { label: "+150", value: "+150" },
  { label: "+151", value: "+151" },
  { label: "+152", value: "+152" },
  { label: "+153", value: "+153" },
  { label: "+154", value: "+154" },
  { label: "+155", value: "+155" },
  { label: "+156", value: "+156" },
  { label: "+157", value: "+157" },
  { label: "+158", value: "+158" },
  { label: "+159", value: "+159" },
  { label: "+160", value: "+160" },
  { label: "+161", value: "+161" },
  { label: "+162", value: "+162" },
  { label: "+163", value: "+163" },
  { label: "+164", value: "+164" },
  { label: "+165", value: "+165" },
  { label: "+166", value: "+166" },
  { label: "+167", value: "+167" },
  { label: "+168", value: "+168" },
  { label: "+169", value: "+169" },
  { label: "+170", value: "+170" },
  { label: "+171", value: "+171" },
  { label: "+172", value: "+172" },
  { label: "+173", value: "+173" },
  { label: "+174", value: "+174" },
  { label: "+175", value: "+175" },
  { label: "+176", value: "+176" },
  { label: "+177", value: "+177" },
  { label: "+178", value: "+178" },
  { label: "+179", value: "+179" },
  { label: "+180", value: "+180" },
  { label: "+181", value: "+181" },
  { label: "+182", value: "+182" },
  { label: "+183", value: "+183" },
  { label: "+184", value: "+184" },
  { label: "+185", value: "+185" },
  { label: "+186", value: "+186" },
  { label: "+187", value: "+187" },
  { label: "+188", value: "+188" },
  { label: "+189", value: "+189" },
  { label: "+190", value: "+190" },
  { label: "+191", value: "+191" },
  { label: "+192", value: "+192" },
  { label: "+193", value: "+193" },
  { label: "+194", value: "+194" },
  { label: "+195", value: "+195" },
  { label: "+196", value: "+196" },
  { label: "+197", value: "+197" },
  { label: "+198", value: "+198" },
  { label: "+199", value: "+199" },
  { label: "+200", value: "+200" },
  { label: "+201", value: "+201" },
  { label: "+202", value: "+202" },
  { label: "+203", value: "+203" },
  { label: "+204", value: "+204" },
  { label: "+205", value: "+205" },
  { label: "+206", value: "+206" },
  { label: "+207", value: "+207" },
  { label: "+208", value: "+208" },
  { label: "+209", value: "+209" },
  { label: "+210", value: "+210" },
  { label: "+211", value: "+211" },
  { label: "+212", value: "+212" },
  { label: "+213", value: "+213" },
  { label: "+214", value: "+214" },
  { label: "+215", value: "+215" },
  { label: "+216", value: "+216" },
];
